import { render, staticRenderFns } from "./ModalCriarSenha.vue?vue&type=template&id=60b9f7ae"
import script from "./ModalCriarSenha.vue?vue&type=script&lang=js"
export * from "./ModalCriarSenha.vue?vue&type=script&lang=js"
import style0 from "./ModalCriarSenha.vue?vue&type=style&index=0&id=60b9f7ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports